// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-block__container {
  background-color: var(--web-primary-color);
}
.dark-block__container h1 {
  color: var(--accent-color);
}

.dark-block__content {
  display: grid;
  font-weight: 900;
  color: var(--white-color);
}

.sub-text {
  color: var(--secondary-text-color);
}

@media only screen and (min-device-width: 320px) {
  .dark-block__container {
    gap: 20px;
  }
  .dark-block__content {
    row-gap: 20px;
    font-size: 36px;
    line-height: 140%;
    letter-spacing: 1.08px;
  }
  .dark-block__content > div {
    gap: 20px;
  }
}
@media only screen and (min-device-width: 768px) {
  .dark-block__container {
    gap: 24px;
  }
  .dark-block__content {
    row-gap: 44px;
    font-size: 44px;
    line-height: 140%;
    letter-spacing: 1.32px;
  }
  .dark-block__content > div {
    gap: 44px;
  }
}
@media only screen and (min-device-width: 992px) {
  .dark-block__container {
    gap: 56px;
  }
  .dark-block__content {
    row-gap: 44px;
    font-size: 68px;
    line-height: 140%;
    letter-spacing: 2.04px;
  }
}
@media only screen and (min-device-width: 1920px) {
  .dark-block__container {
    gap: 56px;
  }
  .dark-block__content {
    row-gap: 44px;
    font-size: 88px;
    line-height: 140%;
    letter-spacing: 2.64px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DarkBlock/darkBlock.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;AACF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;AAAF;;AAEA;EACE,kCAAA;AACF;;AAGA;EACE;IACE,SAAA;EAAF;EAEA;IACE,aAAA;IAEA,eAAA;IACA,iBAAA;IACA,sBAAA;EADF;EAGA;IACE,SAAA;EADF;AACF;AAIA;EACE;IACE,SAAA;EAFF;EAIA;IACE,aAAA;IAEA,eAAA;IACA,iBAAA;IACA,sBAAA;EAHF;EAQA;IACE,SAAA;EANF;AACF;AAyBA;EACE;IACE,SAAA;EAvBF;EAyBA;IACE,aAAA;IAEA,eAAA;IACA,iBAAA;IACA,sBAAA;EAxBF;AACF;AA6BA;EACE;IACE,SAAA;EA3BF;EA6BA;IACE,aAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;EA3BF;AACF","sourcesContent":[".dark-block__container {\n  background-color: var(--web-primary-color);\n\n  h1 {\n    color: var(--accent-color);\n  }\n}\n\n.dark-block__content {\n  display: grid;\n  font-weight: 900;\n  color: var(--white-color);\n}\n.sub-text {\n  color: var(--secondary-text-color);\n}\n\n\n@media only screen and (min-device-width: 320px) {\n  .dark-block__container {\n    gap: 20px;\n  }\n  .dark-block__content {\n    row-gap: 20px;\n\n    font-size: 36px;\n    line-height: 140%;\n    letter-spacing: 1.08px;\n  }\n  .dark-block__content > div {\n    gap: 20px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .dark-block__container {\n    gap: 24px;\n  }\n  .dark-block__content {\n    row-gap: 44px;\n\n    font-size: 44px;\n    line-height: 140%;\n    letter-spacing: 1.32px;\n  }\n  .main-text{\n    //height: 115px;\n  }\n  .dark-block__content > div {\n    gap: 44px;\n  }\n}\n\n//@media only screen and (min-device-width: 992px) {\n//  .dark-block__container {\n//    gap: 56px;\n//  }\n//  .dark-block__content {\n//    row-gap: 44px;\n//\n//    font-size: 68px;\n//    line-height: 140%;\n//    letter-spacing: 2.04px;\n//  }\n//  .main-text{\n//    //height: 213px;\n//  }\n//}\n\n@media only screen and (min-device-width: 992px) {\n  .dark-block__container {\n    gap: 56px;\n  }\n  .dark-block__content {\n    row-gap: 44px;\n\n    font-size: 68px;\n    line-height: 140%;\n    letter-spacing: 2.04px;\n  }\n  .main-text{\n    //height: 213px;\n  }\n}\n@media only screen and (min-device-width: 1920px) {\n  .dark-block__container {\n    gap: 56px;\n  }\n  .dark-block__content {\n    row-gap: 44px;\n    font-size: 88px;\n    line-height: 140%;\n    letter-spacing: 2.64px;\n  }\n  .main-text{\n    //height: 213px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
